/**
 * Resolves Group join CTA copy from backend membership + approval flags.
 */
import { GROUP_STATUS } from '../constants';

type JoinLabelNamespace = 'home.allGroups' | 'groupDetails.options';

interface GroupJoinActionSource {
  status?: string | null;
  requireJoinApproval?: boolean | null;
}

/**
 * Returns the i18n key for the join/status CTA.
 * Approval copy is driven by `requireJoinApproval` from the API — not privacy alone.
 */
export const getGroupJoinActionLabelKey = (
  group: GroupJoinActionSource,
  namespace: JoinLabelNamespace = 'home.allGroups',
): string => {
  const status = group.status;
  const isPending = status === GROUP_STATUS.PENDING;
  const isOwner = status === GROUP_STATUS.OWNER;
  const isJoined = status === GROUP_STATUS.JOINED || isOwner;

  if (isPending) {
    return `${namespace}.pending`;
  }

  if (namespace === 'home.allGroups') {
    if (isOwner) {
      return 'home.allGroups.owner';
    }
    if (isJoined) {
      return 'home.allGroups.joined';
    }
  }

  if (group.requireJoinApproval === true) {
    return `${namespace}.requestToJoin`;
  }

  return `${namespace}.joinGroup`;
};
